import React, { useContext, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useInView } from 'react-intersection-observer';
import { pxToRem } from '../../../es/_util/UnitConvertor';
import TableContext from './TableContext';
import { VIRTUAL_ROOT_MARGIN } from './TableStore';
import TableRow from './TableRow';
const TableVirtualRow = function TableVirtualRow(props) {
    const { index } = props;
    const context = useContext(TableContext);
    const { tableStore } = context;
    const { node } = tableStore;
    const mounted = useRef(false);
    const { ref: intersectionRef, inView, entry } = useInView({
        root: tableStore.overflowY ? node.tableBodyWrap || node.element : null,
        rootMargin: `${VIRTUAL_ROOT_MARGIN}px`,
        initialInView: mounted.current || tableStore.isRowInView(index),
    });
    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);
    const columnsInView = tableStore.columnGroups.inView;
    const height = (!inView || !columnsInView) ?
        entry && entry.target.offsetParent ?
            pxToRem(entry.boundingClientRect.height || entry.target.offsetHeight, true) :
            undefined : undefined;
    return React.createElement(TableRow, Object.assign({}, props, { intersectionRef: intersectionRef, inView: inView, columnsInView: columnsInView, virtualHeight: height }));
};
TableVirtualRow.displayName = 'TableVirtualRow';
export default observer(TableVirtualRow);
